var map = {
	"./product-bh/text.json": [
		7817,
		817
	],
	"./product-en/text.json": [
		2266,
		266
	],
	"./product-kr/text.json": [
		4032,
		32
	],
	"./product-sc/text.json": [
		1633,
		633
	],
	"./product-tc/text.json": [
		7268,
		268
	],
	"./product-th/text.json": [
		2075,
		75
	],
	"./product-vn/text.json": [
		6599,
		599
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5369;
module.exports = webpackAsyncContext;